// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// import "bootstrap";

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("trix")
require("@rails/actiontext")
require("bootstrap-select")
require("@nathanvda/cocoon")

import * as ActiveStorage from "@rails/activestorage"
import "./trix-editor-overrides"
import "./chat"
import "./chat.scss"

ActiveStorage.start()

document.addEventListener("turbolinks:load", () => {
    ('[data-toggle="popover"]').popover(),
    ('[data-toggle="tooltip"]').tooltip(),
    ('[data-toggle="selectpicker"]').selectpicker()
});